import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-alert-view',
  templateUrl: './alert-view.component.html'
})
export class AlertViewComponent implements OnInit {
  public content: string;
  public cancel = true;

  constructor(
    public appConfig: AppConfig,
    public dialogRef: MatDialogRef<AlertViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.content = this.data.content;
    this.cancel = this.data.cancel;
  }

  close(response: number) {
    this.dialogRef.close(response);
  }
}
